import { Component, ViewChild } from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { LaunchDarklyService } from './core/services/launch-darkly.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
  title = 'Provider Directory';

  drawerOpened = false;

  @ViewChild('drawer', {static: true}) public drawer: MatDrawer;

  constructor(private launchDarklyService: LaunchDarklyService) {
  }

  matDrawerToggle(e) {
    this.drawerOpened = e;
    this.drawer.toggle();
  }

  matDrawerClose() {
    this.drawerOpened = false;
  }
}
